import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper';
// import 'swiper/css/swiper.css'
import './styles/app.scss'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {get, baseUrl } from '@/utils/request';
import util from '@/utils/fun'
import * as echarts from 'echarts';
// 解决IE浏览器上出现[vue-router] Failed to resolve async component default: ReferenceError: “Promise”未定义 这是由于es6语法解析不成功造成的
require('es6-promise').polyfill();
require('es6-promise/auto');
//
import 'babel-polyfill';
import titlebox from '@/components/titlebox/titlebox.vue';
import videoBox from '@/components/video/videoBox.vue';
import phoneBooks from '@/components/phoneBooks/phoneBooks.vue';
Vue.component('titlebox', titlebox);
Vue.component('videoBox', videoBox);
Vue.component('phoneBooks', phoneBooks);

Vue.prototype.$echarts = echarts;
import axios from 'axios'
Vue.use(axios);
Vue.prototype.$axios = axios;
Vue.prototype.$get = get;
Vue.prototype.$util = util
Vue.prototype.$imgUrl = baseUrl + "/sys/common/static/"
Vue.prototype.$baseUrl = baseUrl
Vue.prototype.$pdfUrl = baseUrl + '/sys/common/pdf/pdfPreviewIframe/'
Vue.prototype.$defult = require('@/assets/img/party/img1.png');
// 测试
// Vue.prototype.$apiUrlXW = 'http://qsxwgcapi.qhtest.cloudkj.cn:81/project-hope/' //api希望工程
// Vue.prototype.$apiUrlZY = 'http://localhost:8767/' //api志愿者
// Vue.prototype.$openUrlXW = 'http://qhsxwgcweb.qhtest.cloudkj.cn:81/#/projectDetails?index=0&id=' //打开希望工程对应的公益项目

// 试运行
Vue.prototype.$apiUrlXW = 'https://hopeapi.qhgqt.org.cn/' //api希望工程
Vue.prototype.$apiUrlZY = 'https://zyzapi.qhgqt.org.cn/' //api志愿者
Vue.prototype.$openUrlXW = 'https://hope.qhgqt.org.cn/projectDetails?index=0&id=' //打开希望工程对应的公益项目

Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
